import React from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import { useDeleteUser } from "../../../hooks/panelUsers/useDeleteUser";

export const ModalDeleteUser = ({
  open,
  onClose,
  selectedUser,
  token,
  refresh,
}) => {
  const { deleteUser, loading } = useDeleteUser(token);

  const handleSubmit = async () => {
    await deleteUser(selectedUser.id);
    refresh();
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            mb: 4,
          }}
        >
          ¿Estás seguro de que deseas eliminar a{" "}
          <strong>{selectedUser?.user_name}</strong>?
        </Typography>
        <Button
          variant="contained"
          color="error"
          sx={{ mr: 2 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          Eliminar
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
      </Box>
    </Modal>
  );
};
